export default {
  Sending_succeeded: 'Send successfully',
  old_password_no: 'The old password is not allowed to be empty',
  New_password_no: 'The new password cannot be empty, it consists of 6~16 digits and English!',
  Confirm_new_password: 'Confirm the new password cannot be empty, it consists of 6~16 digits and English!',
  re_enter: 'The 2 inputs are inconsistent, please re-enter',
  no_identical: 'The new password cannot be the same as the original password',
  up_password_success: 'Password changed successfully',
  Old_password_error: 'Old password error',
  modify_successfully: 'Modified successfully',
  up_Phone: 'Mobile phone number modified successfully',
  modify_phone: 'Modify mobile phone number',
  dialog_tips: 'Are you sure you want to modify your phone number? After confirming, the old mobile phone number will be verified first. After the verification is passed, verify the new mobile phone number. ',
  old_phone_code: 'Enter the old phone number verification code',
  Modify_contact_name: 'Modify contact name',
  Modify_agent_name: 'Modify agent name',
  Modify_renewal_fs: 'Modify renewal contact information',
  Modify_detailed_address: 'Modify detailed address',
  org_name: 'Modify company name',
  verifying_phone: 'Verifying new phone number...',
  verifying_phone_tow: 'Verifying old phone number...',
  code_success: 'Verification code sent successfully',
  import_phone: 'Enter the verification code of the new mobile phone number',
  Sending_verification_code: 'Sending verification code...',
  old_password_yes: 'Old mobile phone number verification passed',
  New_mobile_number: 'New mobile number',
  Entera_new_phone: 'Enter new phone number',
  Renewal_contact_information: 'Renewal contact information',
  Account_security: 'In order to protect your account security, please complete your personal information first',
  take_back: 'take back ',
  Reset_succeeded: 'Reset succeeded',
  row_passwords: 'The passwords entered twice are inconsistent',
  user_password_no: 'Username or password cannot be empty',
  //共用
  Loggingin: 'Logging in...',
  country: 'Please select a region',
  country1: 'Select a region',
  loading: 'Loading...',
  create_successfully: 'Create successfully! ',
  Pleaseselectanagentfirst: 'Please select an agent first',
  Theminimumsalesquantitysonepiece: 'The minimum sales quantity is one piece',
  Pleaseselectservicecardtype: 'Please select the service card type',
  Insufficientvoicecardbalance: 'Insufficient voice card balance',
  Recordingcardbalanceisinsufficient: 'Recording card balance is insufficient',
  Insufficientbalanceoflocationcard: 'Insufficient balance of location card',
  InsufficientSOScardbalance: 'SOS card balance is insufficient',
  Fencecardbalanceisinsufficient: 'The fence card balance is insufficient',
  Insufficientvideocardbalance: 'Insufficient video card balance',
  Theduplexcardbalanceisinsufficient: 'The duplex card balance is insufficient',
  Insufficientbalanceonvipcard: 'Insufficient balance on VIP card',
  Confirmsalesinformation: 'Confirm sales information',
  servicecardpasswordmistake: 'The entered service card password format is wrong',
  Servicecardpasswordinputerror: 'Service card password input error',
  successfulsales: 'successful sales',
  Pleaseselecttheunitfirst: 'Please select the company first',
  Yourinputisemptypleasereenter: 'Your input is empty, please re-enter! ',
  Theenteredimeinumberisempty: 'The IMEI number you entered is wrong, please re-enter! ',
  Donotaddrepeatedly: 'Do not add repeatedly! ',
  TheQRcodeiswrong: 'QR code is wrong',
  TheIMEInumberiswrong: 'The IMEI number you scanned in is wrong, please scan the code again! ',
  Donotscanthecoderepeatedly: 'Do not scan the code repeatedly',
  Pleaseselectausertype: 'Please select a user type! ',
  Pleaseselectaunit: 'Please select a company',
  Userprefixnicknamecannotbeempty: 'User prefix nickname cannot be empty! ',
  nicknameNoXhx: 'User prefixes and nicknames consist of 2-26 characters.',
  PleaseaddIMEInumber: 'Please add IMEI number! ',
  YoucanadduptoIMEIsbyscanningthecode: 'Up to 100 IMEIs can be added by scanning the code! ',
  YouhaverepeatedlyaddedIMEIpleasedeleteit: 'You have repeatedly added IMEI, please delete it! ',
  Yourvoicecardisinsufficient: 'Your voicecard is insufficient, please recharge first! ',
  Yourrecordingcardisinsufficient: 'Your recordingcard is insufficient, please recharge first! ',
  Yourlocationcardisinsufficient: 'Your location card is insufficient, please recharge first! ',
  YourSOScardisinsufficient: 'Your SOS card is insufficient, please recharge first! ',
  Yourfencecardisinsufficient: 'Your fence card is insufficient, please recharge first! ',
  Yourvideocardisinsufficient: 'Your videocard is insufficient, please recharge first! ',
  Yourduplexcardisnotenough: 'Your duplex card is not enough, please recharge first!',
  Theservicecardpasswordenteredisinthewrongformat: 'The service card password entered is in the wrong format',
  Pleaseselectaregion: 'Please select an area',
  Changeemailaddress: 'Change email address',
  Editdetailedaddress: 'Edit detailed address',
  Bindingplatformisenabled: 'The binding platform is enabled',
  Bindingplatformhasbeenclosed: 'The binding platform has been closed',
  Memberdisplayturnedon: 'Member display turned on',
  Memberdisplayturnedoff: 'Member display turned off',
  Noisecancellationturnedon: 'The noise reduction function has been turned on',
  Noisecancellationturnedoff: 'The noise reduction function has been turned off',
  deleteOrg: 'Are you sure to delete the company information? ',
  successfullydeleted: 'Deleted successfully',
  successfullyset: 'set successfully',
  Thisgroupisalreadythedefaultgroup: 'This group is already the default group! ',
  deletedUserGroup: 'Are you sure to delete the group to which the user belongs? ',
  deletedGroup: 'Are you sure to delete this group? ',
  Youhavenotmodifiedthenoteinformation: 'You have not modified the note information',
  Areyousureyouwanttoremovethismember: 'Are you sure you want to remove this member? ',
  Pleaseselectamembertoadd: 'Please select the member to add',
  Memberaddedsuccessfully: 'Member added successfully',
  Theservicecardpasswordentered: 'The entered service card password format is wrong',
  Thepasswordsenteredtwiceareinconsistent: 'The passwords entered twice are inconsistent, please re-enter',
  successfullyopened: 'Successfully opened!',
  Modifycontactnumber: 'Modify contact number',
  Changeemailaddress: 'Change email address',
  Modifymailingaddress: 'Modify mailing address',
  changeusername: 'Change user name',
  Outofwarrantyandcannotbereplaced: 'The warranty period has expired and cannot be replaced',
  Recycledsuccessfully: 'Recycled successfully',
  restarttheterminaltotakeeffect: 'The modification is successful, restart the terminal to take effect! ',
  UserTalkbackSuspended: 'The user talkback function has been suspended',
  Theuserintercomfunctionisturnedon: 'The user intercom function has been turned on',
  shakeoff: 'shake off',
  Shaketodeath: 'Shake to death',
  Unitdispatcherison: 'company dispatcher is enabled',
  Unitdispatcherisclosed: 'company dispatcher is closed',
  Changeuseraffiliation: `Are you sure you want to change the user's affiliation?`,
  Pleaseselectauser: 'Please select a user',
  PleaseentertheoldIMEIcorrectly: 'Please enter the 15-digit old IMEI correctly',
  PleaseenterthenewIMEIcorrectly: 'Please enter the 15-digit new IMEI correctly',
  Replacedthecardsuccessfully: 'Replaced the card successfully',
  TheoriginalIMEIentereddoesnotexist: 'The original IMEI entered does not exist',
  TheenterednewIMEIisalreadyinuse: 'The entered new IMEI is already in use',
  Cardreplacementfailed: 'Card replacement failed',
  Theverificationcodehasexpiredpleasegetitagain: 'The verification code has expired, please get it again!',
  Pleaseentercorrectverifycode: 'Please enter correct verify code!',
  Verificationcodeerror: 'Verification code error!',
  Pleaseenteramobilephonenumberinthecorrectformat: 'Please enter a mobile phone number in the correct format',
  Pleaseselectthelisteninggrouptobeadded: 'Please select the listening group to be added',
  Confirmtoaddlisteninggroup: 'Confirm to add listening group?',
  Addedsuccessfully: 'Added successfully',
  adding: 'adding...',
  deleting: 'deleting...',
  Areyousuretodeletethislisteninggroup: 'Are you sure to delete this listening group?',
  GPSison: 'GPS is turned on, restart the terminal to take effect!',
  GPSisoff: 'GPS is off, restart the terminal to take effect!',
  Doyouwanttocontinue: 'Check if there are users whose location cards have not expired. Do you want to continue?',
  Renewalsuccessful: 'Renewal successful!',
  IMEIdoesnotexist: 'IMEI does not exist',
  Insufficientservicecardbalance: 'Insufficient service card balance',
  andtheterminalneedstoberestarted: 'The modification of the affiliated unit is successful, and the terminal needs to be restarted',
  Modifytheaffiliatedunitsuccessfully: 'Modify the affiliated unit successfully',
  rOrg_tips: 'The unit name should be 4-20 characters in Chinese, numbers, letters, underscores, and cannot start with an underscore',
  rNamep_tips: ' It should be 2-10 Chinese characters, numbers, letters, underscores, and cannot start with an underscore',
  rNamep_tips20: ' It should be 2-20 Chinese characters, numbers, letters, underscores, and cannot start with an underscore',
  rPhone_tips: ' Mobile phone number format is incorrect',
  rAgent_tips: 'The agent name should be 4-20 characters in Chinese, numbers, letters, underscores, and cannot start with an underscore',
  wAgent_tips: 'The name consists of 1-15 characters in Chinese, numbers, letters, and underscores, and cannot start with an underscore',
  rGroup_tips: 'Group name should be 2-15 characters',
  rGroup2_tips: 'The group name consists of 2-12 digits, Chinese and English',
  rAccount_tips: ' The account number is not allowed to be empty, it should be composed of 6-20 English characters, numbers and underscores',
  rPwd_tips: ' The password should be composed of 6-16 letters and numbers',
  rName_tips: ' It should be 2-7 Chinese characters, numbers, letters, underscores, and cannot start with an underscore',
  rNamep1_tips: 'User nicknames consist of 2-30 characters.',
  rEmail_tips: 'Please enter an email address in the correct format',
  rInt_tips: 'Please enter a positive integer',
  rInputNum_tips: 'Please enter the number',
  rBroad_tips: 'The input content should be Chinese, numbers, letters',
  rVerifyCode_tips: 'Mobile phone verification code is 4 digits',
  rICCID_tips: 'ICCID should be composed of 19 or 20 letters or numbers',
  rIMEI_tips: 'IMEI should be composed of 15 digits',
  removegroupleader: 'Are you sure that removing the group owner will automatically delete this self-created group?',
  removeselfcreatedgroups: 'Are you sure to remove the self-created group and delete it automatically?',
  removeselfcreatedgroupsTow: 'Are you sure you want to change the organization to which the user belongs and automatically delete the user-created group?',
  PleaseselectSOS: 'Please select users who have not turned on SOS service',
  Logintimedout: 'Login timed out!',
  Serverconnectionexception: 'Server connection exception',
  ServerconnectionexceptionLoaing: 'Loading...',
  Nolocationtrack: 'No location track',
  Areyousuretodeletethemember: 'Are you sure to delete the member',
  update_successfully: 'Updated successfully',
  updatecompleted: 'update completed',
  Pleaseselecttheexportdaterange: 'Please select the export date range, the last 90 days',
  Thestarttimecannotbegreaterthantheendtime: 'The start time cannot be greater than or equal to the end time',
  Theendtimecannotbelessthanthestarttime: 'The end time cannot be less than or equal to the start time',
  Areyousureyouwanttodeletethisfence: 'Are you sure you want to delete this fence?',
  Thefencenameisduplicated: 'The fence name is duplicated, please modify it and try again.',
  setptttips: 'Please select the service period',
  Pleaseselectareareplacement: 'Please select area replacement',
  Successfuloperation: 'Successful operation',
  Areyousuretoresettheuserpassword: 'Are you sure to restore the user password?',
  selectedvipcardTpis: 'The selected VIP card user recharge (recording, positioning, SOS, fence) service card will be automatically filtered',
  selectedpttgpscardTpis:'Selected PTT+GPS users will have their location service cards automatically filtered when they top up.',
  closeAgentTips: 'After closure, no information related to the service will be displayed to subordinate agent users. Users within the service period can continue to use the service. Are you sure to close it?',
  vipCardNoTips: 'The recording, GPS, SOS, and electronic fence functions of VIP card users are permanent and do not need to be activated.',
  pttCardNoTips: 'There is no service card that needs to be activated',
  pointtips1:'The user single call function has been enabled',
  pointtips2:"The user's private call function has been disabled",
  LimitspecifiedEnglish: ' select, update, and, or, delete, insert, trancate, char, chr, into, substr, ascii, declare, exec, count, master, drop, execute, script, iframe fields',
  Thecommentcontentcannotcontain: 'The comment content cannot contain',
  Theagentsremarkscannotcontain: "The agent's remarks cannot contain",
  theagencynamecannotcontain:'The agency name cannot contain',
  Thecompanynamecannotcontain:'The company name cannot contain',
  Thegroupnamecannotcontain:'The group name cannot contain',
  Usernamecannotcontain:'User name cannot contain',
  Registeredsuccessfully:'Register account',
  UnbindingUserTips:'Unbinding will clear all company group data and prevent login. Are you sure you want to unbind?',
  Failedtocreategrouppleasebinddevicefirst:'Failed to create group, please bind device first',
  Devicebindingsuccessful:'Device binding successful',
  Devicebindingfaileddifferentownership:'Device binding failed, different ownership',
  Devicebindingfailedaccountdoesnotexist:'Device binding failed, account does not exist',
  Devicebindingfailedalreadybound:'Device binding failed, already bound',
  Devicebindingfailedalreadyexists:'Device binding failed, already exists',
  The_maximum_duration_can_only_be_set_to_60_minutes:'The maximum duration can only be set to 60 minutes.',
  SOS_transmission_interval:'SOS transmission interval',
  Please_set_the_SOS_interval:'Please set the SOS interval.',
  recyclingServiceCardTips:'Once the recycling is confirmed, the user will be deleted, and the consumed service cards will be recycled.',
  Pleasebindthedevicefirst:'Please bind the device first.'
}
